<template>
    <div>
        <section class="internal-page-banner-main col-12">
            <div class="container">
                <div class="row">
                    <div class="page-title">
                        <h1> Forum </h1>
                    </div>
                </div>
            </div>
        </section>
        <div class="internal-page-main-section faq-section-main forum-main col-12">
            <div class="container">
                <div class="MainForum">
                    <div class="ForumTop">
                        <div class="ForumSearch">
                            <div class="input-group">
                                <input v-on:keyup.enter="clearSearch" v-model="search" type="search" placeholder="What're you searching for?" aria-describedby="button-addon4" class="form-control bg-none border-0 forum-input">
                                <div class="input-group-prepend border-0">
                                    <button id="button-addon4" type="button" class="btn btn-link text-info"><i class="fa fa-search"></i></button> 
                                    <button v-on:click.prevent="updateSearchQuestion()" id="button-clear" type="button" class="btn btn-link text-info clear-search"><i class="fa fa-times"></i></button>
                                </div>                  
                            </div>
                        </div>            
                    </div>
                    <div class="ForumButton"> 
                        <button type="button" class="btn btn-primary hvr-sweep-to-right-blue" v-on:click.prevent="clickAskQuestion()">
                            Ask A New Post
                        </button> 
                        <button style="display: none;" type="button" id="openQuestionAsk" data-toggle="modal" data-target="#modal-1" class="btn btn-primary">
                            Ask A New Post
                        </button>
                    </div>
                    <div class="ForumPage">
                        <div class="ForumListing">
                            <h2>Top Asked Posts</h2>
                            <template v-for="(queObj, index) in questionList">
                                <div :key="index" class="ForumQue">
                                    <template v-if="queObj.is_pin_post">
                                        <a href="javascript:void(0);" v-on:click.prevent="clickQuestions(queObj.slug)">
                                            <i class="fa fa-thumb-tack" aria-hidden="true" style="margin-right: 5px;"></i>  {{queObj.question}}
                                        </a>
                                    </template>
                                    <template v-else>
                                        <a href="javascript:void(0);" v-on:click.prevent="clickQuestions(queObj.slug)">
                                            Q. {{queObj.question}}
                                        </a>
                                    </template>
                                </div>    
                            </template>
                        </div>
                    </div>
                </div>
                <div class="clearfix"></div>
                <section v-if="totalQuestions > questionList.length" class="container load_more_container">
                    <button class="btn btn-danger deleteMedia hvr-sweep-to-right-red" v-on:click.prevent="getQuestions()">Load More</button>
                </section>
            </div>
        </div>
        <!-- Modal -->
        <div class="modal fade forum-modal" id="modal-1" role="dialog" ref="modal">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title"><label>Ask Post</label></h4>
                        <!-- data-dismiss="modal" -->
                        <button type="button" class="close" v-on:click="resetModal()">&times;</button>
                    </div>
                    <div class="modal-body">
                        <form ref="form" @submit.stop.prevent="submitAnswer">
                            <div class="row pl-3">
                                <div class="col-12 paddingleft0">
                                    <div class="mt-3 alert alert-danger" id="alertError">
                                        <strong id="errorMsg" class="error"></strong>
                                    </div>
                                </div>
                            </div>
                            <input class="form-control form-control-lg" type="text" placeholder="Ask your Post" v-model="question">
                            <font class="text-danger">{{questionError}}</font>
                            <div class="ForumPopupButton">
                                <div class="dropZoneDiv" style="display: none;">
                                    <font class="text-danger">You can upload maximum {{dropzoneOptions.maxFiles}} file's with a post.</font>
                                    <vue-dropzone
                                        ref="dropzone" 
                                        id="dropzone" 
                                        :options="dropzoneOptions"
                                        @vdropzone-success = "uploadDocument"
                                        @vdropzone-removed-file="removedSelectedFile"
                                        @vdropzone-error="fileError"
                                        @vdropzone-file-added="fileAdd"
                                        @vdropzone-total-upload-progress="progressOfUload"
                                        :useCustomSlot=true
                                        >
                                        <div class="dropzone-custom-content">
                                            <h4 class="dropzone-custom-title">Drop files here or click to upload.</h4>
                                            <div class="subtitle">(Select files from your computer.)</div>
                                        </div>
                                    </vue-dropzone>
                                </div> 
                                <button type="button" class="askquestion btn btn-primary hvr-sweep-to-right-blue" id="SubmitQuestion" v-on:click.prevent="addQuestion()">Ask Post</button>
                                <a href="" v-on:click.prevent="toggleDropZone()" id="addImgBtn" class="addlink hvr-sweep-to-right-red pull-right">Add image</a>   
                            </div>  
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import SessioMixin from '../mixins/sessionmixin';
    import { Button } from 'bootstrap-vue/es/components';
    import {HTTP} from '../http-common';
    import vue2Dropzone from 'vue2-dropzone';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';

    var self;
    export default {
        name: 'forum',
        mixins: [SessioMixin],
        components: {
            vueDropzone: vue2Dropzone,
        },
        data() {
            return {
                dropzoneOptions: {
                    timeout: 3000000,
                    url: process.env.ROOT_API + "/store_document",
                    method: 'POST',
                    paramName: 'file',
                    autoProcessQueue: true,
                    maxFilesize: 150, //MB
                    maxFiles: 4, //ToDo : to decide number of files allowed
                    thumbnailWidth: 150, // px
                    thumbnailHeight: 150,
                    addRemoveLinks: true,
                    duplicateCheck: true,
                    acceptedFiles: ".jpg, .jpeg, .png",
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        // 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE',
                        // 'Access-Control-Allow-Headers': 'Content-Type, Authorization, X-Requested-With',//'Origin, X-Requested-With, Content-Type, Accept, X-File-Name, X-File-Size, X-File-Type',
                        //'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    dictFileTooBig: "File is too big ({{filesize}}mb). Max allowed file size is {{maxFilesize}}mb",
                    dictInvalidFileType: "Invalid File Type",
                    dictCancelUpload: "Cancel",
                    dictRemoveFile: "Remove",
                    dictMaxFilesExceeded: "Only 4 files are allowed",
                    dictDefaultMessage: "Drop files here to upload",
                },
                imagesPaths: [],
                imagesType: [],
                imagesSize: [],
                loadDocArr: [],
                question: "",
                questionError: "",
                search: '',
                questionList: [],
                limit: 9,
                offset: 0,
                totalQuestions: 0,
            }
        },
        watch: {
            search: function (search) {
                if (search.length >= 3) {
                    self.updateSearchQuestion(search);
                }
                if (search.length < 3) {
                    window.localStorage.setItem("forum_question", '');
                }
            },
        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
        },
        mounted: function () {
            $("#alertError").hide();
            self.MenuClose();
            self.search = localStorage.getItem("forum_question");
            self.getQuestions();
            $('#modal-1').on('hidden.bs.modal', function (e) {
                self.question = '';
                self.resetModal();
            });
        },
        methods: {
            clearSearch() {
                window.localStorage.setItem("forum_question", '');
                self.getQuestions();
            },
            resetModal() {
                $('#modal-1').modal('hide');
                self.questionError = '';
                self.removeAllFiles();
                $(".dropZoneDiv").hide();
            },
            handleOk(bvModalEvt) {
                // Prevent modal from closing
                bvModalEvt.preventDefault()
                // Trigger submit handler
                self.submitAnswer()
            },
            submitAnswer() {
                // Hide the modal manually
                self.$nextTick(() => {
                    $('#modal-1').modal('hide');
                });
            },
            updateSearchQuestion(search) {
                search = (search === null || typeof (search) === "undefined" || search == '') ? '' : search;
                self.search = search;
                window.localStorage.setItem("forum_question", self.search);
                self.limit = 9;
                self.offset = 0;
                self.getQuestions();
            },
            getQuestions() {
                self.search = (self.search === null || typeof (self.search) === "undefined" || self.search == '') ? '' : self.search;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        limit: self.limit,
                        offset: self.offset,
                        search: self.search,
                        sort: 'click_count',
                    }
                };
                HTTP.get("searchquestion", config)
                        .then(function (response) {
                            if (self.offset == 0) {
                                self.questionList = [];
                            }
                            $.each(response.data.content.questions, function (i) {
                                self.questionList.push(response.data.content.questions[i]);
                            });
                            self.totalQuestions = response.data.content.total_questions;
                            if (response.data.content.total_questions != self.questionList.length) {
                                self.offset = self.offset + self.limit;
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            clickQuestions(questionSlug) {
                self.$router.push("/forum/" + questionSlug);
            },
            toggleDropZone() {
                $(".dropZoneDiv").toggle("fade");
            },
            clickAskQuestion() {
                var userObj = localStorage.getItem("user_obj");
                if (userObj != null) {
                    $("#openQuestionAsk").click();
                } else {
                    self.checkLogin(window.location.href);
                }
            },
            uploadDocument: function (file, response) {
                //console.log(file);
                /* self.isFileUploaded = true; */
                self.imagesPaths.push(response.content);
                //console.log(self.imagesPaths);
                self.imagesType.push(file.type);
                self.imagesSize.push(file.size);
                this.$refs.dropzone.setOption('maxFiles', 4);
            },
            removedSelectedFile: function (file, xhr, error) {
                /* console.log(JSON.stringify(this.$refs.dropzone.dropzone.options)); */
                this.$refs.dropzone.setOption('maxFiles', 4);
                var removeFile = "";
                if (this.$refs.dropzone.dropzone.options.maxFiles) {
                    this.$refs.dropzone.setOption('maxFiles', 4);
                }
                if ("manuallyAdded" in file == true) {
                    for (var i = self.imagesPaths.length - 1; i >= 0; i--) {
                        if (self.imagesPaths[i].indexOf(file.name) != -1) {
                            removeFile = self.imagesPaths[i];
                        }
                    }
                    this.$refs.dropzone.setOption('maxFiles', 4);
                } else {
                    var filePath = JSON.parse(file.xhr.response);
                    removeFile = filePath.content;
                    //console.log(removeFile);return false;
                    self.removeFileFromServer(removeFile);
                }
                for (var i = self.imagesPaths.length - 1; i >= 0; i--) {
                    if (self.imagesPaths[i] === removeFile) {
                        self.imagesPaths.splice(i, 1);
                        self.imagesType.splice(i, 1);
                        self.imagesSize.splice(i, 1);
                        //break;       //<-- Uncomment  if only the first term has to be removed
                    }
                }
                this.$refs.dropzone.setOption('maxFiles', 4);
                /* console.log(JSON.stringify(this.$refs.dropzone.dropzone.options)); */
            },
            removeFileFromServer: function (filePath) {
                //console.log(filePath);return false;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    data: {
                        filePath: filePath,
                    }
                };
                HTTP.delete('removemedia', config)
                        .then(function (response) {
                            /*console.log("File removed successfully");*/
                        })
                        .catch(function (err) {
                            //self.catchHandler(err, function () {});
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            fileError: function (file, xhr, error) {
                /* console.log("File Error"); */
            },
            fileAdd: function (file, xhr, error) {
                if (this.$refs.dropzone.dropzone.options.maxFiles) {
                    this.$refs.dropzone.setOption('maxFiles', 4);
                }
            },
            uploadManually: function (file) {
                for (var i = 0; i < self.loadDocArr.length; i++) {
                    var url = self.loadDocArr[i]['url'];
                    var file_name = self.getFileName(self.loadDocArr[i]['url']);
                    /*var file_type = self.getFileType(self.loadDocArr[i]['extension']);*/
                    var file_type = self.loadDocArr[i]['file_type'];
                    var file_size = self.loadDocArr[i]['size'];

                    self.imagesType.push(file_type);
                    self.imagesSize.push(Number(file_size));

                    var file_data = {size: file_size, fileid: file_name, name: file_name, type: file_type};
                    self.$refs.dropzone.manuallyAddFile(file_data, url);
                }
            },
            getFileType: function (file_name) {
                var type = file_name.split('.');
                var file_type = type[type.length - 1];
                return 'image/' + file_type;
            },
            getFileName: function (file) {
                var src = file.split('/');
                var file_name = src[src.length - 1];
                var orgPath = src[src.length - 2]
                self.imagesPaths.push(String(orgPath + "/" + file_name));
                return file_name;
            },
            removeAllFiles: function () {
                this.$refs.dropzone.removeAllFiles();
            },
            progressOfUload(totaluploadprogress, totalBytes, totalBytesSent) {
                self.cropError = "";
                if (totaluploadprogress == 100) {
                    $("#SubmitQuestion").prop('disabled', false);
                    /*console.log(totaluploadprogress);
                     console.log(totalBytes);
                     console.log(totalBytesSent);*/
                } else {
                    $("#SubmitQuestion").prop('disabled', true);
                }
            },
            checkForm: function () {
                var checked = true;
                self.questionError = "";
                if (!self.question) {
                    self.questionError = "Question Required";
                    if (checked) {
                        checked = false;
                    }
                }
                return checked;
            },
            addQuestion() {
                if (self.checkForm()) {
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                    };
                    var data = {
                        question: self.question,
                        imagePath: self.imagesPaths,
                        imageSize: self.imagesSize,
                        imageType: self.imagesType,
                    };
                    $("#SubmitQuestion").html("Saving ...");
                    $("#SubmitQuestion").prop("disabled", true);

                    HTTP.post("addupdatequestion", data, config)
                            .then(function (response) {
                                self.removeAllFiles();
                                $("#SubmitQuestion").html("Ask Question");
                                $("#SubmitQuestion").prop("disabled", false);

                                if (response.data.code == 200) {
                                    // self.$router.push('/task/list');
                                    $("#errorMsg").html("Post is added Successfully.");
                                    /*console.log("if");*/
                                    $("#alertError").show();
                                    $(".alert-danger").removeClass("hide");
                                    $(".alert-danger").addClass("show");
                                    self.imagesPaths = [];
                                    self.imagesSize = [];
                                    self.imagesType = [];
                                    self.question = '';
                                    // self.moveToTop();
                                    setTimeout(function () {
                                        $(".alert-danger").removeClass("show");
                                        $(".alert-danger").addClass("hide");
                                        $("#alertError").hide();
                                        self.$nextTick(() => {
                                            $('#modal-1').modal('hide');
                                        });
                                        self.getQuestions();
                                    }, 5000);

                                } else {
                                    $("#alertError").show();
                                    /*console.log('else');*/
                                    if (response.data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < response.data.content.length; i++) {
                                            err += response.data.content[i] + "<br>";
                                        }
                                        $("#errorMsg").html(err);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                    }
                                    setTimeout(function () {
                                        $(".alert-danger").removeClass("show");
                                        $(".alert-danger").addClass("hide");
                                        $("#alertError").hide();
                                    }, 5000);
                                }
                            })
                            .catch(function (err) {
                                self.removeAllFiles();
                                if (err.response.status == 0) {
                                    self.errorMsg = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (err.response.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem("user_obj");
                                        localStorage.removeItem("api_token");
                                        localStorage.removeItem("profile_image");
                                        //EventBus.$emit("logged-in", true, "", "");
                                        self.$router.push("/login");
                                    }
                                    $("#errorMsg").html(err.response.data.message);
                                    $(".alert-danger").removeClass("hide");
                                    $(".alert-danger").addClass("show");
                                    $("#alertError").show();
                                    setTimeout(function () {
                                        $(".alert-danger").removeClass("show");
                                        $(".alert-danger").addClass("hide");
                                        $("#alertError").hide();
                                    }, 5000);
                                }

                            });
                }
            },
        }
    }
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/Forum.vue